/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import EmptyFavoriteTimeIcon from "../assets/icon/empty-favorite-time";
import { Center } from "../styles/general";
import EmailSettings from "./Modal/container/EmailSettings/EmailSettings";
import { useModal } from "./Modal/Modal";
import StyledButton from "./StyledButton";

const TimePickerContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  height: 100%;
  padding: 32px 22px 39px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Title = styled.div`
  font-size: 15px;
  font-weight: 600;
  cursor: default;
  color: rgb(47, 47, 47);
  width: fit-content;
  margin-top: 5px;
  padding: 5px;
  border-radius: 2px;
  height: 28px;
`;

const SubTitle = styled.div`
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #707070;
  margin: 11px 5px;
`;

const Card = styled.div`
  border: 1px solid #dddddd;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const buttonSize = css`
  width: 100px;
  height: 40px;
`;

const ContainerEmpty = styled.div``;

interface Props {
  handleShowFavoriteTime: () => void;
}

export default function EmptyFavoriteTimes(props: Props): JSX.Element {
  const { handleShowFavoriteTime } = props;
  const modal = useModal();

  return (
    <TimePickerContainer>
      <EmptyFavoriteTimeIcon />

      <Title
        css={css`
          text-align: center;
        `}
      >
        No favorite times to show
      </Title>
      <SubTitle>
        You haven’t setup your favorite times yet. Go to Email Settings &gt;
        Favorite Times, <br /> or click the Setup button below.
      </SubTitle>
      <Center
        css={css`
          margin-top: 9px;
        `}
      >
        <StyledButton
          inverted
          css={css`
            margin-right: 13.4px;
            ${buttonSize}
          `}
          onClick={() => handleShowFavoriteTime()}
        >
          Close
        </StyledButton>
        <StyledButton
          css={css`
            ${buttonSize}
          `}
          onClick={() => {
            modal.pushModal(<EmailSettings />, "Email Settings", false, true);
          }}
        >
          Setup
        </StyledButton>
      </Center>
    </TimePickerContainer>
  );
}
